import React from 'react';

function PlayerProfiles({ selected1, selected2, stats1, stats2, loading1, loading2 }) {
  if (!selected1 || !selected2) {
    return null;
  }
  
  return (
    <div>
      <h3 style={{textAlign: "center"}}>Profils détaillés</h3>
      
      <div style={{
        display: "flex", 
        flexDirection: "column",
        gap: "20px",
        marginTop: "20px"
      }}>
        <div style={{
          padding: "15px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9"
        }}>
          <h4>{selected1.player}</h4>
          <p>
            <strong>Classement Elo :</strong> {selected1.elo_rank}<br />
            <strong>Classement ATP :</strong> {selected1.atp_rank}<br />
            <strong>Âge :</strong> {selected1.age} ans<br />
            <strong>Elo pic :</strong> {selected1.peak_elo} ({selected1.peak_month})
          </p>
          
          {loading1 || (stats1 && stats1.message) ? (
            <div style={{ color: "#aaa", fontSize: 14 }}>
              {stats1 ? stats1.message : "Chargement des stats avancées..."}
            </div>
          ) : null}

          <div style={{textAlign: "center", marginTop: "15px"}}>
            <a 
              href={selected1.profile_url} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                background: "#3498db",
                color: "white",
                padding: "8px 15px",
                borderRadius: "4px",
                textDecoration: "none",
                fontWeight: "bold"
              }}
            >
              Voir statistiques complètes sur tennisabstract.com
            </a>
          </div>
        </div>
        
        <div style={{
          padding: "15px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9"
        }}>
          <h4>{selected2.player}</h4>
          <p>
            <strong>Classement Elo :</strong> {selected2.elo_rank}<br />
            <strong>Classement ATP :</strong> {selected2.atp_rank}<br />
            <strong>Âge :</strong> {selected2.age} ans<br />
            <strong>Elo pic :</strong> {selected2.peak_elo} ({selected2.peak_month})
          </p>

          {loading2 || (stats2 && stats2.message) ? (
            <div style={{ color: "#aaa", fontSize: 14 }}>
              {stats2 ? stats2.message : "Chargement des stats avancées..."}
            </div>
          ) : null}
          
          <div style={{textAlign: "center", marginTop: "15px"}}>
            <a 
              href={selected2.profile_url} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                background: "#3498db",
                color: "white",
                padding: "8px 15px",
                borderRadius: "4px",
                textDecoration: "none",
                fontWeight: "bold"
              }}
            >
              Voir statistiques complètes sur tennisabstract.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayerProfiles; 